
import { Options, Vue } from "vue-class-component";
import LabelAndValue from "@/components/general/LabelAndValue.vue";
import store from "@/store";
import i18n from "@/i18n";
import { globalConfig } from "@/utils";
import { SummaryRating } from "@/types";

const HIDDEN_RATING_TYPES = ["score", "avis"];

@Options({
  components: { LabelAndValue },
})
export default class SummaryCotation extends Vue {
  capitalize = globalConfig.capitalize;
  valueStyle = {
    "font-weight": "bold",
    "margin-left": "20px",
    color: "black",
  };
  divValueStyle = {
    display: "flex",
    "justify-content": "end",
    "padding-right": "10px",
  };
  labelStyleItem = {
    "font-size": "1rem",
    color: "gray",
    "font-weight": "bold",
  };

  get visibleRatings(): SummaryRating[] {
    return (store.state.summaryPanelModule.analysisRatings || []).filter((rating) => {
      const type = this.normalizeType(rating.type);
      return type !== "" && !HIDDEN_RATING_TYPES.includes(type);
    });
  }

  ratingLabel(type: unknown): string {
    const raw = String(type ?? "").trim();
    if (!raw) {
      return "-";
    }
    const key = `task.study.${raw}`;
    if (i18n.global.te(key)) {
      return i18n.global.t(key);
    }
    return raw;
  }

  ratingDisplayValue(rating: SummaryRating): string {
    if (!this.isEmpty(rating.decision)) {
      return this.translateDecision(String(rating.decision));
    }
    if (!this.isEmpty(rating.updatedValue)) {
      return String(rating.updatedValue);
    }
    if (!this.isEmpty(rating.calculatedValue)) {
      return String(rating.calculatedValue);
    }
    return "-";
  }

  translateDecision(decision: string): string {
    const summaryKey = `summaryPanel.cotation.decision.${decision}`;
    if (i18n.global.te(summaryKey)) {
      return i18n.global.t(summaryKey);
    }
    const studyKey = `task.study.${decision}`;
    if (i18n.global.te(studyKey)) {
      return i18n.global.t(studyKey);
    }
    return decision;
  }

  normalizeType(type: unknown): string {
    return String(type ?? "").trim().toLowerCase().replace(/\s+/g, "");
  }

  isEmpty(value: unknown): boolean {
    if (value === undefined || value === null) {
      return true;
    }
    const asString = String(value).trim();
    return asString === "" || asString.toLowerCase() === "null";
  }
}
